import { useAppInstanceId } from "../../navigation/appInstances";
import { appInstancesApi } from "../../services/api/appInstances";
import FileListTabPage from "../files/FileListTabPage";

export default function AppInstanceFilesTabPage() {
    return <FileListTabPage api={appInstancesApi.files} ownerId={useAppInstanceId()} />;
}
